import { API_BASE } from '../config';
import { textsEqualForSearch } from '@narrativebench/editor-core';

export interface ExistingProjectResource {
  id: string;
  fileName: string;
  title: string;
  url: string | null;
}

export async function fetchExistingProjectResources(
  token: string,
  projectId: string,
  input: { url?: string; fileNames?: string[] }
): Promise<ExistingProjectResource[]> {
  try {
    const response = await fetch(
      `${API_BASE}/api/projects/${projectId}/resources/check-existing`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(input),
      }
    );

    if (!response.ok) {
      return [];
    }

    const data = await response.json() as { resources?: ExistingProjectResource[] };
    return Array.isArray(data.resources) ? data.resources : [];
  } catch (error) {
    console.error('Error checking existing resources:', error);
    return [];
  }
}

export function isExistingFileName(fileName: string, existingFileNames: string[]): boolean {
  return existingFileNames.some((name) => textsEqualForSearch(name, fileName));
}
